import { connect } from "react-redux";
import {
  createFolder,
  loadAllUserFolders,
  loadFolderCalculs,
  manageCalculsFolders,
} from "../actions";
import { ModalAssignCalculToFolders } from "../components/modals/ModalAssignCalculToFolders";
import { loadUserCalculs } from "../../calcul/actions";

export default connect(
  (state) => ({
    allFolders: state.folders.allFolders,
  }),
  (dispatch) => ({
    loadAllUserFolders: () => dispatch(loadAllUserFolders()),
    createFolder: (folderDatas) => dispatch(createFolder(folderDatas)),
    manageCalculsFolders: (data) => dispatch(manageCalculsFolders(data)),
    loadUserCalculs: () => {
      dispatch(loadUserCalculs());
    },
    loadFolderCalculs: (folderId) => {
      dispatch(loadFolderCalculs(folderId));
    },
  }),
)(ModalAssignCalculToFolders);
